import { Controller } from "@hotwired/stimulus"

// Mobile off-canvas sidebar drawer for the new (Tailwind) UI.
// Put data-controller="tw-sidebar" on the layout wrapper; the sidebar <aside> is the
// "panel" target and the dimmed overlay is the "backdrop" target. The topbar hamburger
// fires tw-sidebar#toggle. On md+ the sidebar is static, so this only matters on mobile.
export default class extends Controller {
  static targets = ["panel", "backdrop"]

  connect() {
    this.onKey = this.onKey.bind(this)
    document.addEventListener("keydown", this.onKey)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKey)
  }

  toggle() {
    this.opened ? this.close() : this.open()
  }

  open() {
    this.panelTarget.classList.remove("-translate-x-full")
    this.panelTarget.classList.add("translate-x-0")
    if (this.hasBackdropTarget) this.backdropTarget.classList.remove("hidden")
    this.opened = true
  }

  close() {
    this.panelTarget.classList.add("-translate-x-full")
    this.panelTarget.classList.remove("translate-x-0")
    if (this.hasBackdropTarget) this.backdropTarget.classList.add("hidden")
    this.opened = false
  }

  onKey(event) {
    if (event.key === "Escape") this.close()
  }
}
